<template>
    <div class="com-card">
        <div class="com-card-title">{{ payload.name }}<span class="right-txt">¥{{ form.tree.price * form.quantity || '' }}</span></div>
        <div class="com-card-content">
            <div class="text-wrap com-text-justify">
                <div v-html="payload.brief?.replace(/\n/gi, '<br>')" />
            </div>
            <br>
            <div class="van-hairline--bottom" />
            <br>
            <div class="com-form-wrap">
                <van-form ref="form">
                    <van-field
                        class="field-yellow"
                        v-model="form.tree.treeName"
                        readonly
                        clickable
                        colon
                        label="林木品种"
                        placeholder="请选择认供林木品种"
                        :rules="[{ required: true, message: '请选择认供林木品种' }]"
                        @click="showPicker = true"
                    />
                    <van-field
                        class="field-yellow"
                        label="林木规格"
                        readonly
                        colon
                    >
                        <template #input>
                            {{ form.tree.specification || '请选择认供林木品种' }}
                        </template>
                    </van-field>

                    <van-field
                        label="选择认供数量"
                        colon
                    >
                        <template #input>
                            <van-stepper v-model="form.quantity" :max="form.tree.stock" />
                        </template>
                    </van-field>
                </van-form>
                <br>
                <div class="com-form-submit">
                    <DefaultBtn @click="unifiedOrder">登记信息</DefaultBtn>
                </div>
            </div>
        </div>
    </div>
    <van-popup v-model:show="showPicker" :close-on-click-overlay="false" position="bottom">
        <van-picker
            visible-item-count="3"
            :columns="columns.map(v => v.treeName)"
            @confirm="selectTree"
            @cancel="showPicker = false"
        />
    </van-popup>
</template>

<script>
    export default {
        props: {
            payload: Object,
            default: () => {}
        },
        data () {
            return {
                form: {
                    tree: {
                        treeName: null,
                        stock: 99
                    },
                    quantity: 1
                },
                columns: [],
                showPicker: false
            }
        },
        mounted () {
            this.getDateList()
        },
        methods: {
            // 跳转登记信息页面
            unifiedOrder () {
                this.$refs.form.validate().then(err => {
                    if (!err) {

                        // 以时间戳为key，存储页面数据
                        const timestamp = Date.now()

                        localStorage.setItem(timestamp, JSON.stringify({
                          // 功德林
                            type: 3,
                            price: this.form.tree.price,
                            quantity: this.form.quantity,
                            pId: this.payload.id,
                            id: this.form.tree.id,
                            pageData: {
                                ...this.payload,
                                name: `${this.payload.name} - ${this.form.tree.treeName}`,
                                goodId: this.form.tree.goodsId
                            }
                        }))
                        this.$router.push({
                            path: 'record',
                            query: { timestamp }
                        })
                    }
                })
            },
            selectTree (value) {
                this.form.tree = this.columns.find(v => v.treeName == value)
                this.showPicker = false
            },
            // 查询纪念日列表
            getDateList () {
                this.$faWuApi.fuTian.getTreeList({
                    page: 1,
                    limit: 999,
                    pId: this.payload.id
                }).then(res => {
                    if (res.success) {
                        this.columns = res.data.list.filter(v => v.stock > 0)
                    }
                })
            }
        },
        components: {
        }
    }
</script>
